import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AuthService} from '../../auth.service';
import {Store} from '@ngxs/store';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {Permission} from 'jugacu-lib';
import {WhistlerAPIService} from '../../whistler-api.service';

@Component({
    selector: 'app-permission',
    templateUrl: './permission.component.html',
    styleUrls: ['./permission.component.scss']
})
export class PermissionComponent implements OnInit {

    @Input()
    set permissions(permissions: Permission[]) {
        this.internalPermissions = permissions;
        this.permissionCtrl.setValue(null);
    }

    internalPermissions: Permission[];

    @Output() OnAdd: EventEmitter<Permission> = new EventEmitter();
    @Output() OnRemove: EventEmitter<Permission> = new EventEmitter();

    @Input()
    loading = false;

    @ViewChild('inputElement')
    inputElement: ElementRef<HTMLInputElement>;


    internalLoading = true;

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;

    allPermissions: Permission[] = [];
    filteredPermissions: Observable<Permission[]>;
    separatorKeysCodes = [ENTER, COMMA];
    permissionCtrl = new FormControl();

    constructor(
        private authService: AuthService,
        private readonly whistlerAPIService: WhistlerAPIService,
        private store: Store
    ) {
        this.filteredPermissions = this.permissionCtrl.valueChanges.pipe(
            startWith(null),
            map((permissionName: string) => permissionName ? this.filter(permissionName) : this.allPermissions.slice()),
            map(permissions => permissions.filter(perm => !this.internalPermissions.map(perms => perms.name).includes(perm.name))),
        );
    }

    async ngOnInit() {
        try {
            const response = await this.whistlerAPIService.getPermissionList();
            this.allPermissions = response.data;
        } catch (e) {
            //
        } finally {
            this.internalLoading = false;
        }
    }

    async selected(event: MatAutocompleteSelectedEvent) {
        const permission = this.allPermissions.find((p) => p.name === event.option.viewValue);
        if (!permission) {
            return;
        }

        await this.requestAddition(permission);
        this.permissionCtrl.setValue(null);
    }

    async add(event: MatChipInputEvent) {
        const input = event.input;
        const value = event.value;

        const permission = this.allPermissions.find((p) => p.name === value);
        if (!permission) {
            return;
        }

        await this.requestAddition(permission);
    }

    private filter(value: string): Permission[] {
        const filterValue = value.toLowerCase();

        return this.allPermissions.filter(permission => permission.name.toLowerCase().indexOf(filterValue) === 0);
    }

    private async requestAddition(permission: Permission) {
        this.inputElement.nativeElement.value = '';
        this.permissionCtrl.setValue(null);
        this.OnAdd.emit(permission);
    }

    async remove(permission: Permission) {
        this.inputElement.nativeElement.value = '';
        this.permissionCtrl.setValue(null);
        this.OnRemove.emit(permission);
    }
}
